import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import Calendar from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Calendar';
import FamilyHeart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/FamilyHeart';
import GraduationHatWithTassle from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/GraduationHatWithTassle';
import HeartWithCross from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/HeartWithCross';
import PottedPlantWithDollarSignCircle from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PottedPlantWithDollarSignCircle';
import ThreePeopleConnectedByOuterLines from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ThreePeopleConnectedByOuterLines';
// native components
import UnderstandingProductGrouping from '../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'recruitment-campaign-get-rewarded',
    icon: PottedPlantWithDollarSignCircle,
    title: <>Get rewarded for what you <WidowBlock>put in</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Here, hard work pays off. Plus, the value of your business grows over time providing ongoing revenue streams.
      </Typography>
    ),
  },
  {
    id: 'recruitment-campaign-control-over-schedule',
    icon: Calendar,
    title: <>Control over <WidowBlock>your schedule</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Earn the independence to work when it works for you.
      </Typography>
    ),
  },
  {
    id: 'recruitment-campaign-work-for-yourself',
    icon: ThreePeopleConnectedByOuterLines,
    title: <>Work for yourself, not <WidowBlock>by yourself</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Backed by a <strong><em>FORTUNE&#174; 500</em></strong> company, you&#39;ll have the financial support and professional guidance to grow.
      </Typography>
    ),
  },
  {
    id: 'recruitment-campaign-training-programs',
    icon: GraduationHatWithTassle,
    title: <>World&#45;class training programs</>,
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Set yourself up for success with our nationally recognized fast track training, specialized career paths, and ongoing development.
      </Typography>
    ),
  },
  {
    id: 'recruitment-campaign-family-planning-benefits',
    icon: FamilyHeart,
    title: 'Family planning benefits',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        From adoption assistance to maternity leave, have the support to balance your life with your career.
      </Typography>
    ),
  },
  {
    id: 'recruitment-campaign-healthcare',
    icon: HeartWithCross,
    title: 'Comprehensive healthcare',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Get more than just medical with dental and vision coverage, and more.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='recruitment-campaign'
      headingText={<>Benefits that go above <WidowBlock>and beyond</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
